import { Injectable } from '@angular/core';
import { AppConfig } from '../../app.config';
declare var window: any;

export interface Config {
  apiUrl: string;
  clientUrl: string;
  aiKey: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  sytemConfiguration: Config;

  constructor() {
    this.loadConfigurations();
  }

  private loadConfigurations(): any {
    let currentConfig: Config;
    switch (window.location.hostname) {
      case this.getHostName(AppConfig.Production.clientUrl):
        currentConfig = AppConfig.Production;
        break;
      case this.getHostName(AppConfig.Uat.clientUrl):
        currentConfig = AppConfig.Uat;
        break;
      case this.getHostName(AppConfig.Qa.clientUrl):
        currentConfig = AppConfig.Qa;
        break;
      case this.getHostName(AppConfig.Development.clientUrl):
        currentConfig = AppConfig.Development;
        break;
      default:
        currentConfig = AppConfig.Local;
    }
    this.sytemConfiguration = currentConfig;

    return currentConfig;
  }

  private getHostName(url: string): string {
    return url.replace('https://', '').replace('/', '');
  }
}
